/**
 * Created by tschrader on 30.01.2017.
 */
export function navigateToURL(urlOrRequest: string | any, windowname: string = "_blank"): any {
    if (typeof urlOrRequest !== "string" && "url" in urlOrRequest) {
        urlOrRequest = urlOrRequest.url;
    }
    window.open(urlOrRequest, windowname);
};
